import { lazy } from 'react';

// project imports
import { Invoice } from 'views/invoice/Invoice';
import { PreorderInvoice } from 'views/preorder/invoice/PreorderInvoice';
import { PreorderInvoiceManage } from 'views/managementPreorder/invoice/PreorderInvoiceManage';
import { InvoiceCustomer } from 'views/shopsCustomer/invoiceCustomer/InvoiceCustomer';
import { Receipt } from 'views/shopsCustomer/receiptCustomer/Receipt';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import Agent from 'views/agent/Agent';
import DashboardDefault from 'views/dashboard/Default';

const StockImportList = Loadable(lazy(() => import('views/financial/importstock/StockImportList')));
const WhatsAppPage = Loadable(lazy(() => import('views/financial/whatsapp/WhatsAppPage')));
const ReceiptInvoiceList = Loadable(lazy(() => import('views/inventory/Receipt/ReceiptInvoiceList')));
const ReportInventoryImport = Loadable(lazy(() => import('views/reportStockController/A-one/ReportInventoryImport')));
const ChangeRequestList = Loadable(lazy(() => import('views/changeRequest/history/ChangeRequestList')));
const ChangeRequestComplete = Loadable(lazy(() => import('views/adminController/changeRequest/ChangeRequestComplete')));
const SftpUpload = Loadable(lazy(() => import('views/adminController/sftpUpload/SftpUpload')));
const ReportTexts = Loadable(lazy(() => import('views/adminController/reportTexts/ReportTexts')));
const ChangeRequestApproval = Loadable(lazy(() => import('views/approvalController/changeRequest/ChangeRequestApproval')));
const ChangeRequest = Loadable(lazy(() => import('views/changeRequest/ChangeRequest')));
const ReportCreditInvoiceHistory = Loadable(lazy(() => import('views/financial/reports/ReportCreditInvoiceHistory')));
const ReportCreditNoteHistory = Loadable(lazy(() => import('views/financial/reports/ReportCreditNoteHistory')));
const ReportPremiumsHistory = Loadable(lazy(() => import('views/reportStockController/A-one/ReportPremiumsHistory')));
const Claimpromotion = Loadable(lazy(() => import('views/financial/claimpromotion/Claimpromotion')));
const ReportAgingStock = Loadable(lazy(() => import('views/reportStockController/A-one/ReportAgingStock')));
const HistoryWallet = Loadable(lazy(() => import('views/financial/aoneWallet/HistoryWallet')));
const ReportFota = Loadable(lazy(() => import('views/reportStockController/SamsungFOTA/ReportFota')));
const Product = Loadable(lazy(() => import('views/products/Product')));
const Customer = Loadable(lazy(() => import('views/customer/Customer')));
const Inventory = Loadable(lazy(() => import('views/inventory/import/Inventory')));
const ExchangeRateController = Loadable(lazy(() => import('views/exchangeRate/ExchangeRateController')));
const Preorder = Loadable(lazy(() => import('views/preorder/Preorder')));
const PreorderInvoiceConsign = Loadable(lazy(() => import('views/consignment/preorderConsign/invoice/PreorderInvoice')));
const PreorderConsign = Loadable(lazy(() => import('views/consignment/preorderConsign/Preorder')));
const AoneWalletController = Loadable(lazy(() => import('views/financial/aoneWallet/AoneWalletController')));
const MovementReport = Loadable(lazy(() => import('views/reportStockController/A-one/movmentReport/MovementReport')));
const ShopsCustomer = Loadable(lazy(() => import('views/shopsCustomer/ShopsCustomer')));
const ExchangeRateControllerCustomer = Loadable(
    lazy(() => import('views/shopsCustomer/exchangeRateCustomer/ExchangeRateControllerCustomer'))
);
const MovementReportCustomer = Loadable(lazy(() => import('views/shopsCustomer/movmentReport/MovementReportCustomer')));
const InventoryReportCustomer = Loadable(lazy(() => import('views/shopsCustomer/reportCustomer/InventoryReportCustomer')));
const SaleReport = Loadable(lazy(() => import('views/shopsCustomer/reportCustomer/SaleReport')));
const ReportSaleToCustomer = Loadable(lazy(() => import('views/reportStockController/A-one/ReportSaleToCustomer')));
const ReportSalePremiumsToCustomer = Loadable(lazy(() => import('views/reportStockController/A-one/ReportSalePremiumsToCustomer')));
const ReportDashboardStockCustomer = Loadable(lazy(() => import('views/reportStockController/Customer/ReportDashboardStockCustomer')));
const ReportSaleSummary = Loadable(lazy(() => import('views/reportStockController/A-one/ReportSaleSummary')));
const ReportEDI_Sale_File = Loadable(lazy(() => import('views/reportStockController/A-one/ReportEDI_Sale_File')));
const ReportEDI_Sale_File_VIP = Loadable(lazy(() => import('views/reportStockController/Customer/ReportEDI_Sale_File_VIP')));
const PremiumController = Loadable(lazy(() => import('views/premiums/controller')));
const ImportPremiums = Loadable(lazy(() => import('views/premiums/imports/ImportPremiums')));
// const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const Shops = Loadable(lazy(() => import('views/shops/Shops')));
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));
const CheckoutConfirm = Loadable(lazy(() => import('views/checkout/CheckoutConfirm')));
const CheckoutConfirmCustomer = Loadable(lazy(() => import('views/shopsCustomer/checkoutCustomer/CheckoutConfirmCustomer')));
const SamplePage = Loadable(lazy(() => import('views/sample-page')));
const Receiptbill = Loadable(lazy(() => import('views/inventory/Receipt/Receipt')));
const PremiumStock = Loadable(lazy(() => import('views/premiums/stock/PremiumStock')));
const ImportFOTA = Loadable(lazy(() => import('views/reportStockController/SamsungFOTA/import/ImportFOTA')));
const ReportsPreorder = Loadable(lazy(() => import('views/reports/reportsPreorder/ReportPreorder')));
const InvoiceReport = Loadable(lazy(() => import('views/reports/invoiceReport/Invoice')));
const SaleReports = Loadable(lazy(() => import('views/reports/saleReport/SaleReports')));
const ReportDashboardVIP = Loadable(lazy(() => import('views/reports/vip/ReportDashboardVIP')));
const SaleReportsVIP = Loadable(lazy(() => import('views/reports/vip/saleReportVIP/SaleReportsVIP')));
const Location = Loadable(lazy(() => import('views/consignment/location/Location')));
const RequestList = Loadable(lazy(() => import('views/consignment/management/RequestList')));
const CreateTemporaryInvoice = Loadable(lazy(() => import('views/consignment/createTemporaryInvoice/CreateTemporaryInvoice')));
const TemporaryInvoiceListTrack = Loadable(
    lazy(() => import('views/consignment/createTemporaryInvoice/temporaryInvoiceListTrack/TemporaryInvoiceListTrack'))
);
const TemporaryInvoiceList = Loadable(lazy(() => import('views/consignment/management/temporaryInvoice/TemporaryInvoiceList')));
const CreditNoteList = Loadable(lazy(() => import('views/financial/aoneWallet/credit/CreditNoteList')));
const CreditNoteApproval = Loadable(lazy(() => import('views/approvalController/creditNote/CreditNoteApproval')));
const AnnouncementRequirement = Loadable(lazy(() => import('views/financial/announcement/AnnouncementRequirement')));
const AnnouncementApproval = Loadable(lazy(() => import('views/approvalController/announcement/AnnouncementApproval')));
const CreditInvoiceApproval = Loadable(lazy(() => import('views/approvalController/creditInvoice/CreditInvoiceApproval')));
const WithdrawalApproval = Loadable(lazy(() => import('views/approvalController/withdrawal/WithdrawalApproval')));
const InventoryDashboard = Loadable(lazy(() => import('views/reports/inventoryDashboard/InventoryDashboard')));
const CreditInvoiceManagement = Loadable(lazy(() => import('views/financial/creditInvoice/CreditInvoiceManagement')));
const ReportAgingCreditIvoice = Loadable(lazy(() => import('views/financial/reports/ReportAgingCreditIvoice')));
const ReportCreditNoteUsage = Loadable(lazy(() => import('views/financial/reports/ReportCreditNoteUsage')));
const CreditInvoiceVerify = Loadable(lazy(() => import('views/financial/creditInvoice/verifyCreditInvoice/CreditInvoiceVerify')));
const CashbackVerify = Loadable(lazy(() => import('views/financial/cashbackInvoice/CashbackVerify')));
const CashbackApproval = Loadable(lazy(() => import('views/approvalController/cashbackInvoice/CashbackApproval')));
const QrPaymentVerify = Loadable(lazy(() => import('views/financial/qrPayment/verifyQrPayment/QrPaymentVerify')));
const QrPaymentApproval = Loadable(lazy(() => import('views/approvalController/qrPayment/QrPaymentApproval')));
const ReportSaleAndStockCompare = Loadable(lazy(() => import('views/financial/reports/ReportSaleAndStockCompare')));
const ReportSaleAndStockMovement = Loadable(lazy(() => import('views/financial/reports/ReportSaleAndStockMovement')));
const ReportAgingDashboard = Loadable(lazy(() => import('views/reportStockController/A-one/ReportAgingDashboard')));

// const Consignment = Loadable(lazy(() => import('views/consignment/consign/Consignment')));
// const ConsignHistory = Loadable(lazy(() => import('views/consignment/history/ConsignHistory')));
// ==============================|| MAIN ROUTING ||============================== //

function MainRoutes() {
    const children = [
        {
            path: '*',
            element: <DashboardDefault />
        },
        {
            path: '/',
            element: <DashboardDefault />
        },
        {
            path: '/dashboard/default',
            element: <DashboardDefault />
        }
    ];
    if (localStorage.getItem('role')) {
        const Roles = localStorage.getItem('role').split(',');
        // console.log(Roles.includes("18"));
        if (Roles.includes('38')) {
            children.push(
                {
                    path: '/menu/preorder',
                    element: <Preorder />
                },
                {
                    path: '/menu/preorder/invoice',
                    element: <PreorderInvoice />
                },
                {
                    path: '/menu/request/consignment',
                    element: <PreorderConsign />
                },
                {
                    path: '/menu/request/consignment/track/stock',
                    element: <PreorderInvoiceConsign />
                },
                {
                    path: '/menu/request/invoice/temporary',
                    element: <CreateTemporaryInvoice />
                },
                {
                    path: '/menu/request/consignment/track/temporaryinvoice',
                    element: <TemporaryInvoiceListTrack />
                },
                {
                    path: '/menu/request/changerequest',
                    element: <ChangeRequest />
                },
                {
                    path: '/menu/list/changerequest',
                    element: <ChangeRequestList />
                }
            );
        }
        if (Roles.includes('47')) {
            children.push(
                {
                    path: '/stockcustomer/shops',
                    element: <ShopsCustomer />
                },
                {
                    path: '/stockcustomer/invoice',
                    element: <InvoiceCustomer />
                },
                {
                    path: '/stockcustomer/receipt',
                    element: <Receipt />
                },
                {
                    path: '/stockcustomer/checkout',
                    element: <CheckoutConfirmCustomer />
                },
                {
                    path: '/stockcustomer/exchangerate',
                    element: <ExchangeRateControllerCustomer />
                },
                {
                    path: '/stockcustomer/history',
                    element: <MovementReportCustomer />
                },
                {
                    path: '/stockcustomer/report/inventory',
                    element: <InventoryReportCustomer />
                },
                {
                    path: '/stockcustomer/report/sale',
                    element: <SaleReport />
                },
                {
                    path: '/stockcontroller/report/fota/import',
                    element: <ImportFOTA />
                },
                {
                    path: '/stockcontroller/report/fota',
                    element: <ReportFota />
                }
            );
        }

        if (Roles.includes('18')) {
            children.push(
                {
                    path: '/stockcontroller/inventory/import',
                    element: <Inventory />
                },
                {
                    path: '/stockcontroller/inventory/receipt',
                    element: <Receiptbill />
                },
                {
                    path: '/stockcontroller/inventory/importlist',
                    element: <ReceiptInvoiceList />
                },
                {
                    path: '/stockcontroller/movement',
                    element: <MovementReport />
                },
                {
                    path: '/stockcontroller/report/saletocustomer',
                    element: <ReportSaleToCustomer />
                },
                {
                    path: '/stockcontroller/report/inventoryimport',
                    element: <ReportInventoryImport />
                },
                {
                    path: '/stockcontroller/report/salepremiumstocustomer',
                    element: <ReportSalePremiumsToCustomer />
                },
                {
                    path: '/stockcontroller/report/agingstock',
                    element: <ReportAgingStock />
                },
                {
                    path: '/stockcontroller/report/agingstockdashboard',
                    element: <ReportAgingDashboard />
                },
                {
                    path: '/stockcontroller/report/aonesalesummary',
                    element: <ReportSaleSummary />
                },
                {
                    path: '/stockcustomer/reports/inventorydashboard',
                    element: <InventoryDashboard />
                },
                {
                    path: '/stockcustomer/report/dashboardvip',
                    element: <ReportDashboardStockCustomer />
                },
                {
                    path: '/stockcontroller/report/edisalefile',
                    element: <ReportEDI_Sale_File />
                },
                {
                    path: '/stockcontroller/report/edisalefilevip',
                    element: <ReportEDI_Sale_File_VIP />
                },
                {
                    path: '/stockcontroller/agent',
                    element: <Agent />
                },
                {
                    path: '/stockcontroller/shops',
                    element: <Shops />
                },
                {
                    path: '/shops/checkout',
                    element: <CheckoutConfirm />
                },
                {
                    path: '/stockcontroller/invoice',
                    element: <Invoice />
                }
            );
        }
        if (Roles.includes('5')) {
            children.push({
                path: '/stockcontroller/product',
                element: <Product />
            });
        }
        if (Roles.includes('50')) {
            children.push(
                {
                    path: '/stockcontroller/premiums/stock',
                    element: <PremiumStock />
                },
                {
                    path: '/stockcontroller/premiums',
                    element: <PremiumController />
                },
                {
                    path: '/stockcontroller/premiums/import',
                    element: <ImportPremiums />
                },
                {
                    path: '/stockcontroller/premiums/history',
                    element: <ReportPremiumsHistory />
                }
            );
        }
        if (Roles.includes('57')) {
            children.push({
                path: '/stockcontroller/consignment/addlocation',
                element: <Location />
            });
            children.push({
                path: '/stockcontroller/consignment/requirement',
                element: <RequestList />
            });
            children.push({
                path: '/stockcontroller/consignment/temporaryinvoice',
                element: <TemporaryInvoiceList />
            });
            // children.push({
            //     path: '/stockcontroller/consignment/consign',
            //     element: <Consignment />
            // });
            // children.push({
            //     path: '/stockcontroller/consignment/history',
            //     element: <ConsignHistory />
            // });
        }
        if (Roles.includes('22')) {
            children.push({
                path: '/menu/customer',
                element: <Customer />
            });
        }

        if (Roles.includes('31')) {
            children.push({
                path: '/financial/exchangerate',
                element: <ExchangeRateController />
            });
        }

        if (Roles.includes('34')) {
            children.push({
                path: '/financial/aonewallet',
                element: <AoneWalletController />
            });
            children.push({
                path: '/financial/aonewallet/history',
                element: <HistoryWallet />
            });
            children.push({
                path: '/financial/aonewallet/credit',
                element: <CreditNoteList />
            });
            children.push({
                path: '/financial/aonewallet/creditinvoice',
                element: <CreditInvoiceManagement />
            });
            children.push({
                path: '/financial/aonewallet/Verify/creditinvoice',
                element: <CreditInvoiceVerify />
            });
            children.push({
                path: '/financial/aonewallet/Verify/cashback',
                element: <CashbackVerify />
            });
            children.push({
                path: '/financial/aonewallet/verify/qrpayment',
                element: <QrPaymentVerify />
            });
            children.push({
                path: '/financial/aonewallet/announcement',
                element: <AnnouncementRequirement />
            });
            children.push({
                path: '/financial/claimcheck',
                element: <Claimpromotion />
            });
            children.push({
                path: '/financial/stockimportlist',
                element: <StockImportList />
            });
            children.push({
                path: '/financial/whatsapp',
                element: <WhatsAppPage />
            });
            children.push({
                path: '/financial/report/agingcreditinvoice',
                element: <ReportAgingCreditIvoice />
            });
            children.push({
                path: '/financial/report/creditnoteusage',
                element: <ReportCreditNoteUsage />
            });
            children.push({
                path: '/financial/report/credithistory',
                element: <ReportCreditNoteHistory />
            });
            children.push({
                path: '/financial/report/creditinvoicehistory',
                element: <ReportCreditInvoiceHistory />
            });
            children.push({
                path: '/financial/report/saleandstockcompare',
                element: <ReportSaleAndStockCompare />
            });
            children.push({
                path: '/financial/report/saleandstockmovement',
                element: <ReportSaleAndStockMovement />
            });
        }
        if (Roles.includes('39')) {
            children.push({
                path: '/stockcontroller/preorder',
                element: <PreorderInvoiceManage />
            });
        }
        if (Roles.includes('53')) {
            children.push({
                path: '/reports/preorder',
                element: <ReportsPreorder />
            });
            children.push({
                path: '/reports/invoice',
                element: <InvoiceReport />
            });
            children.push({
                path: '/reports/sales',
                element: <SaleReports />
            });
            children.push({
                path: '/reports/vip/dashboard',
                element: <ReportDashboardVIP />
            });
            children.push({
                path: '/reports/vip/sales',
                element: <SaleReportsVIP />
            });
        }
        ///approval
        if (Roles.includes('61')) {
            children.push({
                path: '/approval/creditnote',
                element: <CreditNoteApproval />
            });
            children.push({
                path: '/approval/creditinvoice',
                element: <CreditInvoiceApproval />
            });
            children.push({
                path: '/approval/cashback',
                element: <CashbackApproval />
            });
            children.push({
                path: '/approval/announcement',
                element: <AnnouncementApproval />
            });
            children.push({
                path: '/approval/withdrawal',
                element: <WithdrawalApproval />
            });
            children.push({
                path: '/approval/changerequest',
                element: <ChangeRequestApproval />
            });
            children.push({
                path: '/approval/qrpayment',
                element: <QrPaymentApproval />
            });
        }
        //admin
        if (Roles.includes('99')) {
            children.push({
                path: '/admin/changerequest',
                element: <ChangeRequestComplete />
            });
            children.push({
                path: '/admin/sftpupload',
                element: <SftpUpload />
            });
            children.push({
                path: '/admin/reporttexts',
                element: <ReportTexts />
            });
        }
    }
    // console.log(children);
    const routes = {
        path: '/',
        element: <MainLayout />,
        children: children
        //     [
        //     {
        //         path: '*',
        //         element: <DashboardDefault />
        //     },
        //     {
        //         path: '/',
        //         element: <DashboardDefault />
        //     },
        //     {
        //         path: '/dashboard/default',
        //         element: <DashboardDefault />
        //     },
        //     // {
        //     //     path: '/utils/util-typography',
        //     //     element: <UtilsTypography />
        //     // },
        //     // {
        //     //     path: '/utils/util-color',
        //     //     element: <UtilsColor />
        //     // },
        //     // {
        //     //     path: '/utils/util-shadow',
        //     //     element: <UtilsShadow />
        //     // },
        //     // {
        //     //     path: '/icons/tabler-icons',
        //     //     element: <UtilsTablerIcons />
        //     // },
        //     // {
        //     //     path: '/icons/material-icons',
        //     //     element: <UtilsMaterialIcons />
        //     // },
        //     // {
        //     //     path: '/sample-page',
        //     //     element: <SamplePage />
        //     // },
        //     {
        //         path: '/stockcontroller/product',
        //         element: <Product />
        //     },
        //     {
        //         path: '/stockcontroller/agent',
        //         element: <Agent />
        //     },
        //     {
        //         path: '/menu/customer',
        //         element: <Customer />
        //     },
        //     {
        //         path: '/menu/shops',
        //         element: <Shops />
        //     },
        //     {
        //         path: '/stockcontroller/inventory/import',
        //         element: <Inventory />
        //     },
        //     {
        //         path: '/shops/checkout',
        //         element: <CheckoutConfirm />
        //     },
        //     {
        //         path: '/stockcontroller/inventory/receipt',
        //         element: <Receiptbill />
        //     },
        //     {
        //         path: '/menu/invoice',
        //         element: <Invoice />
        //     },
        //     {
        //         path: '/menu/preorder',
        //         element: <Preorder />
        //     },
        //     {
        //         path: '/menu/preorder/invoice',
        //         element: <PreorderInvoice />
        //     },
        //     {
        //         path: '/financial/exchangerate',
        //         element: <ExchangeRateController />
        //     },
        //     {
        //         path: '/financial/aonewallet',
        //         element: <AoneWalletController />
        //     }
        // ]
    };
    return routes;
}

export default MainRoutes;
